"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.VoucherReducer = exports.VoucherClearData = exports.VoucherClearData_success = exports.VOUCHER_CLEAR_DATA_SUCCESS = undefined;

var _nodeToolbox = require("@esnpm/node-toolbox");

var _apiVoucher = require("../actions/esdb/apiVoucher");

var _index = require("immutability-helper/index");

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// setzt data von aktuell geladenem Voucher auf null
var VOUCHER_CLEAR_DATA_SUCCESS = exports.VOUCHER_CLEAR_DATA_SUCCESS = "VOUCHER_CLEAR_DATA_SUCCESS";
var VoucherClearData_success = exports.VoucherClearData_success = function VoucherClearData_success(options) {
	return {
		type: VOUCHER_CLEAR_DATA_SUCCESS
	};
};
var VoucherClearData = exports.VoucherClearData = function VoucherClearData(options) {
	return function (dispatch, getState) {
		return new Promise(function (resolve, reject) {
			try {
				dispatch(VoucherClearData_success(options));
				resolve();
			} catch (e) {
				reject(e);
			}
		});
	};
};

var VoucherReducer = exports.VoucherReducer = function VoucherReducer() {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
		data: null,
		loading: false,
		error: null
	};
	var action = arguments[1];

	var newState = void 0;

	switch (action.type) {
		case _apiVoucher.API_VOUCHER_SUCCESS:
			return Object.assign({}, action.payload);
			break;

		case VOUCHER_CLEAR_DATA_SUCCESS:
			//setzte voucher daten wieder auf null
			newState = (0, _index2.default)(state, {
				data: {
					$set: null
				}
			});
			return newState;
			break;
		default:
			return state;
	}
};